<div fxLayout="row" fxLayoutGap="2px" fxLayoutAlign="space-between start">
    <app-loader *ngIf="State.IsLoading"></app-loader>
</div>

<div fxLayout="row" class="h-100-p mat-nav mat-elevation-z2 background-white" fxLayoutGap="2px" fxFill>
    <!-- <div fxFlex="calc(20% - 10px)" fxHide.lt-md class="mat-white-500-bg">
        <app-document-tree-view [dmsConfig]="dmsConfig" [projectId]="dmsConfig.OrganizationId" [folderChange]="folderChange"></app-document-tree-view>
    </div> -->

    <div fxFlex="100%" class="center" (dragover)="Actions.DragOver($event)">
        <div id="drop-mask" (dragleave)="Actions.DragLeave($event)" (drop)="Actions.Drop($event)"></div>
        <div class="content h-100-p" fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="space-between center" style="z-index: 0 !important" class="
                    dms-header
                    background
                    mat-elevation-z2
                    background-white
                    px-16
                    py-8
                ">
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <p class="dms-title" *ngIf="!State.IsLoading">
                        <span class="cursor-pointer" (click)="Actions.BreadcrumbClick('', 0)">
                            {{ Breadcrumbs[0].Name | translate }}
                            <span *ngIf="Breadcrumbs.length > 1"> > </span>
                        </span>
                        <span *ngIf="Breadcrumbs.length > 2">
                            <button mat-icon-button [matMenuTriggerFor]="bMenu">
                                <i class="material-icons">more_horiz</i>
                            </button>
                            <mat-menu #bMenu="matMenu">
                                <ng-container *ngFor="
                                        let crumb of Breadcrumbs
                                            | slice: 1:Breadcrumbs.length - 1;
                                        let i = index
                                    ">
                                    <button *ngIf="crumb.OriginalObjectArtifactId" mat-menu-item (click)="
                                            Actions.BreadcrumbClick(
                                                crumb.OriginalObjectArtifactId,
                                                i + 1
                                            )
                                        ">
                                        <span>{{ crumb.Name }}</span>
                                    </button>
                                    <button *ngIf="!crumb.OriginalObjectArtifactId" mat-menu-item (click)="
                                            Actions.BreadcrumbClick(
                                                crumb.ItemId,
                                                i + 1
                                            )
                                        ">
                                        <span>{{ crumb.Name }}</span>
                                    </button>
                                </ng-container>
                            </mat-menu>
                            <span> > </span>
                        </span>
                        <span *ngIf="Breadcrumbs.length > 1">
                            <ng-container *ngFor="
                                    let crumb of Breadcrumbs;
                                    last as isLast;
                                    let ii = index
                                ">
                                <span *ngIf="isLast">{{ crumb.Name }}</span>
                            </ng-container>
                        </span>
                    </p>
                </div>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
          
                </div>
            </div>
   
            <mat-sidenav-container [style.height]="'100%'" class="dms-container" [hasBackdrop]="false" fxFlex
                fxLayout="column">
                <mat-sidenav class="left-border pt-20" #Sidenav position="end" [mode]="'side'" [disableClose]="false"
                    id="information-section">
                </mat-sidenav>

                <mat-sidenav-content>
                    <div fxFlex [ngClass]="{
                            dragging: State.IsDraggingOver,
                            'p-14': !State.IsDraggingOver
                        }">
                        <div fxFlex fxLayout="column" fxLayoutAlign="center center" *ngIf="
                                MyDrive?.Folders.length === 0 &&
                                MyDrive?.Files.length === 0 &&
                                !State.IsLoading
                            ">
                            <app-empty-list *ngIf="
                                    createFileAndFolderPermission;
                                    else noFileAndFolder
                                "></app-empty-list>
                            <ng-template #noFileAndFolder>
                                <div class="noFileAndFolderFound h-200" fxLayoutAlign="center center">
                                    {{
                                    'DMS_FILE_FOLDER_NOT_FOUND' | translate
                                    }}
                                </div>
                            </ng-template>
                        </div>

                        <app-document-list-grid-view *ngIf="
                                State.ViewMode === 'Grid' &&
                                (MyDrive?.Folders.length > 0 ||
                                    MyDrive?.Files.length > 0)
                            " [State]="State" [MyDrive]="MyDrive" [UserId]="UserId"
                            (SelectEvent)="Actions.Select($event)" [dmsConfig]="dmsConfig" fxFlex>
                        </app-document-list-grid-view>
                    </div>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </div>
    </div>

    <input type="file" accept="*/*" multiple id="FileBrowser" #FileBrowser (click)="FileBrowser.value = ''"
        (change)="Actions.UploadByBrowsing($event.target['files'])" style="display: none" />
</div>